export const NORTH_AMERICA_COUNTRIES = ['US', 'CA'];

export enum RegistrationStage {
  NotSubmitted = 0,
  ReviewingInfo = 1,
  RegistrationComplete = 2,
  DataError = 3,
  CampaignError = 4,
}
